import './search.css';
import React, { Component } from 'react';
import Translator from './../../requests/apa/Translator';
import { withKeyboard } from '../../components/FormGroup';
import Scrollable from '../../components/Scrollable';
import Ribbon from '../../components/Ribbon';
import RequestManager from '../../requests/RequestManager';
import predictiveSearchTask from '../../requests/tasks/search/predictiveSearchTask';
import Utils from '../../utils/Search';
import AnalyticsDimensionSingleton from '../../components/Header/AnalyticsDimensionSingleton';
import SearchFlag from './SearchFlag';
import {getContentAvailability, getNavDataNodeByCode, getNavDataNodeById} from '../../utils/Utils';
import {GA4} from 'src/utils/trackers/GA4';
import { ClearTextSearch } from '../../components/PersistentMiniEpg/MiniObserver';
import LoadingIptvOttFlow from 'src/AAF/LoaderExp/LoadingIptvOttFlow';
import {removeDynamicFocus} from "../../components/Focus/utils";
import UtilsSearch from "./UtilsSearch";
import Utilsu from '../../utils/Utils';

class Search extends Component {
  constructor() {
    super();
    this.state = {
      predictive: null,
      suggest: null,
      flag: false,
      text: '',
    };
    this.searchTimeOut = null;
    this.hasFocused=this.hasFocused.bind(this);
    this.makeScrolleable = this.makeScrolleable.bind(this);
    this.pTalents = {external_talents: {gracenote: [], keyApa: 'predictSearch_external_talents_label', typeCarousel:'user-profile'}};
    ClearTextSearch.subscribe(this.clearTextSearch);
    this.divScrolleable = null;
    this.isMagicControlActive = Utilsu.getMagicControlKey();
  }

  componentDidMount() {
    //window.SpatialNavigation.makeFocusable();
    this.addEventListeners();
    SearchFlag.setFlag(false);

    if(!LoadingIptvOttFlow.isLoadLive()){
      this.props && (typeof this.props.loadLinealChannels == 'function') && this.props.loadLinealChannels();
      this.props && (typeof this.props.chargeLiveComponents == 'function') && this.props.chargeLiveComponents();
    }
    if (this.divScrolleable) {
      this.divScrolleable.addEventListener('wheel', this.handleScroll, true);
      this.divScrolleable.addEventListener('pointerMove', this.handleScroll, true);
    }
  }

  componentWillUnmount() {
    removeDynamicFocus()
    this.removeEventListeners();
    SearchFlag.setFlag(false);
    ClearTextSearch.unsubscribe(this.clearTextSearch);
    if (this.divScrolleable) {
      this.divScrolleable.removeEventListener('wheel', this.handleScroll, true);
      this.divScrolleable.removeEventListener('pointerMove', this.handleScroll, true);
    }
  }

  componentDidUpdate() {
    if(SearchFlag.getFlag()){
      SearchFlag.setFlag(false);
      if(this.props && (typeof this.props.resetValues === 'function')){
        this.props.resetValues();
      }
    }
  }

  addEventListeners() {
    this.searchContainerRef.addEventListener("sn:focused", this.hasFocused);

  }

  removeEventListeners() {
    this.searchContainerRef.removeEventListener("sn:focused", this.hasFocused);

  }

  clearTextSearch = () => {
    console.log('Desmontando el componente');
    SearchFlag.setFlag(true);
    this.setState({
      predictive: null,
      suggest: null,
      flag: true,
      text: '',
    })
  };

  hasFocused(e) {
    if(e.detail.direction==='right'){
      this.sendMetric();
    }else if(e.detail.direction==='down' || e.detail.direction==='up'){
      if(!e.target.classList.contains('form-group-focus')){
        var element=e.target.parentNode.parentNode.parentNode;
        element.scrollIntoView(false);
      }
    }
  }



  sendDimension(){
    const payload=new AnalyticsDimensionSingleton().getPayload();
    this.props.setMetricsEvent(payload);
    this.props.setMetricsEvent({ type: 'executor'});
  }


  sendMetric(){
    if(window.location.toString().indexOf('search')!==-1) {
      if (typeof this.props.setMetricsEvent === 'function' && typeof this.props.setMetricFlag === 'function' && typeof this.props.getMetricFlag === 'function') {
        const text = this.props.formValues.input_search_0;


        if (text !== '' && this.props.getMetricFlag() === false) {
          this.props.setMetricsEvent({
            hitType: 'event',
            eventCategory: 'busqueda',
            eventAction: 'palabra/frase buscada',
            eventLabel: text
          });
          this.props.setMetricsEvent({type: 'executor'});
          this.sendDimension();
          this.props.setMetricFlag(true);
        }

      }
    }
  }

  sendGA4Metric(text) {
    const gA4 = new GA4();
    gA4.sendSearchEvent(text);
  }

  isComponentSerch(){
    const isActiveSearch = document.activeElement.className;
    if ( isActiveSearch === '' && ( isActiveSearch.includes !== 'kbd-btn' && isActiveSearch !==  'form-group-value form-group-value-text ')) {
      return false;
    }else{
      return true;
    }
  }

  searchByText(text) {

    if(!this.isComponentSerch()) return;

    if (this.searchTimeOut)
      clearTimeout(this.searchTimeOut);

    this.props.setMetricFlag(false);

    if (text != this.state.text) {
      this.searchTimeOut = setTimeout(() => {

        if (text && text.length && text.length >=3) {
          this.sendGA4Metric(text)
        }

        const searchTask = new predictiveSearchTask({ value: text });
        RequestManager.addRequest(searchTask)
          .then((data) => {
            let prediction;
            let movie;

            if (data.response != null) {
              this.setState({
                predictive: data.response.prediction,
                suggest: data.response.suggest,
                flag: true,
                text: text,
              })
            }
            else {
              if (text == '') {
                this.setState({
                  flag: false,
                  text: '',
                })
              }
              else this.setState({ flag: false })

            }

          })
          .catch((e) => {
            console.log(e);
            this.setState({ flag: false })
          });
      }, 1000);
    }

  }

  isEmpty = (obj) => {
    for(let key in obj) {
      if(obj.hasOwnProperty(key))
        return false;
    }
    return true;
  };

  setValuesTalentsAndExternal(result){
    const talentsProperties = result.map(talent => ({
      first_name: talent.first_name,
      id: talent.id,
      image: talent.image,
      internal_ids: talent.internal_ids,
      last_name: talent.last_name,
      fullname: `${talent.last_name} ${talent.first_name}`,
      provider: talent.type ? '2' : '3'
    }));

    return this.setEventhandle(talentsProperties);
  }

  setValuesTalents(resultTalents){
    let result=[];
    for(var y in resultTalents){
      var arrinternal_ids=[];
      let tmpTalent=resultTalents[y];
      if(tmpTalent){
        arrinternal_ids.push(tmpTalent.id);
        tmpTalent.first_name=tmpTalent.name.split(' ')[0];
        tmpTalent.last_name=tmpTalent.name.split(' ')[1];
        tmpTalent.internal_ids=arrinternal_ids;
        result.push(tmpTalent);
      }
    }
    return this.setValuesTalentsAndExternal(result);
  }


  setEventhandle(talentsProperties){
    return talentsProperties.map(talent => ({
      first_name: talent.first_name,
      id: talent.id,
      image: talent.image,
      internal_ids: talent.internal_ids,
      last_name: talent.last_name,
      fullname: `${talent.last_name} ${talent.first_name}`,
      provider: talent.provider,
      clickHandler: () => {
        this.handleTalentClick(talent);
      }
    }));
  }

  handleTalentClick = talent => {
    const { history } = this.props;
    history.push(`/talent/${talent.id}/${talent.fullname}/${talent.provider}`);
  };

  combineTalents(talents,external_talents){
    let result=[];
    for(var x in external_talents){
      if(external_talents[x]){
        result.push(external_talents[x]);
      }
    }
    for(var y in talents){
      var arrinternal_ids=[];
      let tmpTalent=talents[y];
      if(tmpTalent){
        arrinternal_ids.push(tmpTalent.id);
        tmpTalent.first_name=tmpTalent.name.split(' ')[0];
        tmpTalent.last_name=tmpTalent.name.split(' ')[1];
        tmpTalent.internal_ids=arrinternal_ids;
        result.push(tmpTalent);
      }
    }

    return this.setValuesTalentsAndExternal(result);
  }

  handleScroll(event) {
    removeDynamicFocus();
  }

  setRefScroll = (element) => {
    if(this.isMagicControlActive){
        this.divScrolleable = element;
    }
  }

  makeScrolleable(predictive, suggest) {
    let newSuggest={}, ribbon;
    let keySuggest = 'suggests';
    const { text } = this.state;

    //Se validan si ambos atributos existen, si existen ambos se procede con la union.
    if(predictive.talents && predictive.external_talents){
      //Se toma la llave de external_talents como prioridad para pintarse
      if(predictive.external_talents && predictive.external_talents!==undefined) {
        predictive.external_talents.gracenote = this.combineTalents(predictive.talents.talent,predictive.external_talents.gracenote);
        //delete predictive.talents;
      }
    }
    else if(predictive.talents === undefined && predictive.external_talents){
      predictive.external_talents.gracenote = this.setValuesTalentsAndExternal(predictive.external_talents.gracenote);
    }
    else if(predictive.talents  && !predictive.external_talents){
      Object.assign(predictive, this.pTalents);
      predictive.external_talents.gracenote = this.setValuesTalents(predictive.talents.talent);
    }


    if(suggest.length !== 0 ){
      newSuggest.suggest=suggest;
    }
    const prediction = Utils.parserSections(predictive);
    const searchPriority = Utils.getSearchPriority();
    if(searchPriority.searchPriority.length != 0) {
      const foundKey = searchPriority.searchPriority.filter(key => key.indexOf('suggest') > -1);
      keySuggest = foundKey.length > 0 ? foundKey : keySuggest;
    }

    prediction[keySuggest] = newSuggest;

    if (Object.keys(predictive).length !== 0 || suggest.length !== 0) {
      let _prediction = Utils.handler(prediction);
      _prediction=Utils.orderPriority(_prediction);

        const idsRibbonsUpAndDown = UtilsSearch.createObjectsWithIdsUpDown(_prediction);

        ribbon = Object.keys(_prediction).map((key, index) => {
        let data;
        if (_prediction[key]) {
          data = Object.keys(_prediction[key]).map((k, i) => {
            let comp = (item, type, title, key, title_default) => {
              return item.length < 2 && type === 'text' ? null : (<Ribbon
                id={"buscador"}
                key={i}
                title={Translator.get(title, title_default)}
                type={type}
                items={item}
                hideInnerTitle={true}
                setMetricsEvent={this.props.setMetricsEvent}
                carruselTitle={Translator.get(title, key)}
                user={this.props.user}
                idsRibbonsUpAndDown={idsRibbonsUpAndDown}
                index={index}
              />)
            }

            if (k != 'keyApa' || k != 'typeCarousel') {
              if (Array.isArray(_prediction[key][k])) {
                return (comp(_prediction[key][k],
                  _prediction[key].typeCarousel,
                  _prediction[key].keyApa,
                  key,
                  _prediction[key].textDefault
                ))
              }

            }
          })
        }

        return data;
      })
    }
    return (<Scrollable height={'540px'} className="results">
      {this.isEmpty(predictive) && suggest.length == 0 && this.state.flag == true && <div>
        {Translator.get('search_empty_result_text', 'Lo sentimos! Parece que no hay coincidencias')} {`${text}`}
      </div>}
      {
        this.state.flag === true &&
        <div className={this.isMagicControlActive ? "search-result-with-scroll" : ""}
        ref={this.setRefScroll}>
          {ribbon}
        </div>
      }
    </Scrollable>)
  }

  render() {
    let predictive = Object.assign({}, this.state.predictive);
    let suggest = [];

    if (this.state.suggest){
      suggest = Utils.getSuggest(this.state.suggest);
    }

    return (
      <div className="main search" ref={el => {this.searchContainerRef = el; this.setRefScroll(el);}}>
        {this.props.renderGroup(
          'input_search_0',
          Translator.get('search_result_welcome', 'Ingresa tu búsqueda'),
          'text',
          null,
          (text = '') => {
            if (text != this.state.text) this.searchByText(text)
          }
        )}
        {this.makeScrolleable(predictive, suggest)}
      </div>)
  }
}
const formValues = {
  input_search_0: ''
};
export default withKeyboard(Search, formValues);



// WEBPACK FOOTER //
// ./src/containers/Search/index2.jsx